import React, { useState } from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import './Home.css';
import hero_title from '../../assets/hero_title.png';
import play_icon from '../../assets/play_icon.png';
import info_icon from '../../assets/info_icon.png';
import TitleCards from '../../Components/TitleCards/TitleCards';
import Footer from '../../Components/Footer/Footer';
import SearchCard from '../../Components/SearchCard/SearchCard';
function Home() {
  const [searchMovie,setSearchMovie]=useState("");
  console.log(searchMovie);
  return (
    <div className='wrapper'>
    <header className='header'>
         <div className='hero'>
        <Navbar setSearchMovie={setSearchMovie}/>
        <div className='container'>
    <div className='hero_content'>
    <div >
        <img className='title_img' src={hero_title} alt='title'/>
    </div>
    <p>Discovering his ties to a secret ancient order, a young man living in modern Istanbul embarks on a quest to save the city from an immortal enemy</p>
    <div className='hero_btn'>
        <button className='play_btn'><img src={play_icon} alt='playbtn'/>Play</button>
        <button className='info_btn'><img src={info_icon} alt='playbtn'/>More Info</button>
    </div>
    </div>
         </div>
    </div>
    </header>
    {
      searchMovie && <SearchCard searchMovie={searchMovie}/>
    }
    
    <TitleCards/>
    <TitleCards title="Blockbuster Movies"/>
    <TitleCards title="Only on Netflix"/>
    <TitleCards title="Upcoming"/>
    <TitleCards title="Top Pics for You"/>
    <Footer/>
    </div>
  )
}

export default Home